class LocalStorageWrapper {
    private storageKey: string;

    constructor(storageKey: string) {
        this.storageKey = storageKey;
    }

    public set(placeName: string) {
        localStorage.setItem(this.storageKey, placeName);
    }

    public get(): string | null {
        return localStorage.getItem(this.storageKey);
    }

    public clear() {
        localStorage.removeItem(this.storageKey);
    }
}

export const clearLocalStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.document.cookie = "";
};

export const PostSignupAction = new LocalStorageWrapper("postSignupAction");
export const PostSignupNotification = new LocalStorageWrapper("postSignupNotification");

export const AcceptedTestConsent = new LocalStorageWrapper("acceptedTestConsent");
export const TestUserLog = new LocalStorageWrapper("testUserLog");

export const BetaSurveyDismissed = new LocalStorageWrapper("betaSurveyDismissed");
export const BetaSurveyPopupDismissed = new LocalStorageWrapper("betaSurveyPopupDismissed");

export const UserOrganization = new LocalStorageWrapper("userOrganization");
